// Same-origin proxy prefixes — regional upstreams are chosen in src/proxy.ts.
export const CDN_BASE_URL = "/_cdn";
export const ORDER_HUB_PUBLIC_BASE_URL = "/_backend/public/order-hub";
export const ORDER_HUB_API_BASE_URL = "/_backend/api/order-hub";
export const SESSION_BASE_URL = "/_backend/session";
